$(function(){
    console.log('Register.js loaded');
    $(":input").inputmask();
    // Inputmask().mask(document.querySelectorAll("input"));




    $( ".ac-opcina" ).autocomplete({
        create: function () {
            $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                return $('<li>')
                    .append('<span><b>' + fix_na(ucwords(item.NAZIV)) + '</b>, ' + item.P_BROJ + '</span>')
                    // .append('<span><b>' + item.NAZ_PAR + '</b>, ' + item.ADRESA + ' [' + item.SIF_PAR + ']</span>')
                    .appendTo(ul);
            };
            
        },
        source: function( request, response ) {
             
             $.ajax({
                url: urls.opcina_search,
                data: {term: request.term },            
                dataType: "json",
                type: "POST",
                
               success: function( data ) {
                   
    
                   if(validate_ajax_response(data)){
                    
                        for(var i=0; i<data.dataset.data.length;i++){
                            data.dataset.data[i].label=data.dataset.data[i].NAZIV.trim();
                            // data.dataset.data[i].label=data.dataset.data[i].NAZ_PAR.trim()+' ['+data.dataset.data[i].SIF_PAR+']';
                        }
    
                        response( data.dataset.data );
                    }
               }
                
            });
            
          },
          minLength: 2,
          open: function(){
                $('.ui-autocomplete').scrollTop(0);
          },
          select: function( event, ui ) {
            //console.log( ui.item );
            
            $('[name=city_id]').val(ui.item.SIF_OPC);
                       

          },
          change: function (event, ui) {
            if(!ui.item){
                $(".ac-opcina").val("");  //force selection
            }
        }
      }); 
   
});

function fix_na(str) {
    return str.replace(' Na ',' na ');
}
function ucwords (str) {
    str=str.toLowerCase()
    return (str + '').replace(/^([a-z])|\s+([a-z])|\(([a-z])|\-([a-z])/g, function ($1) {
        return $1.toUpperCase();
    });
}